<template>
  <v-list two-line>
    <template v-for="(event, $i) in order(events)">
      <v-divider :key="$i" v-if="$i !== 0"></v-divider>
      <v-list-item :key="'i' + $i">
        <v-list-item-content>
          <v-list-item-title v-html="event.type" />
          <v-list-item-subtitle v-html="event.information" />
        </v-list-item-content>

        <v-list-item-action>
          <v-list-item-action-text>{{
            event.created | dateFormat
          }}</v-list-item-action-text>

          <v-list-item-action-text>{{ event.user }}</v-list-item-action-text>
        </v-list-item-action>
      </v-list-item>
    </template>
  </v-list>
</template>

<script>
import { format } from 'date-fns'
import orderBy from 'lodash.orderby'

export default {
  name: 'InquiriesEvents',

  filters: {
    dateFormat: v => format(new Date(v), 'yyyy-MM-dd HH:mm'),
  },

  props: {
    inquiry: Object,
  },

  computed: {
    events() {
      return this.inquiry.events
    },
  },

  methods: {
    order(arr) {
      return orderBy(arr, ['created'], ['desc'])
    },
  },
}
</script>
